import { z } from 'zod';
export var ExternalAccountProvider;
(function (ExternalAccountProvider) {
    ExternalAccountProvider["SIMPLEFIN"] = "SIMPLEFIN";
    ExternalAccountProvider["GO_CARDLESS"] = "GO_CARDLESS";
})(ExternalAccountProvider || (ExternalAccountProvider = {}));
// External Account types
export const externalAccountSchema = z.object({
    id: z.string().uuid(),
    userId: z.string().uuid(),
    provider: z.nativeEnum(ExternalAccountProvider),
    providerId: z.string(),
    name: z.string(),
    institutionName: z.string().optional(),
    institutionDomain: z.string().optional(),
    currency: z.string(),
    balance: z.coerce.number(),
    balanceDate: z.string().datetime(),
    syncTime: z.string().datetime(),
    timeCreated: z.string().datetime(),
    timeModified: z.string().datetime(),
});
// External Transaction types
export const externalTransactionSchema = z.object({
    id: z.string().uuid(),
    userId: z.string().uuid(),
    externalAccountId: z.string().uuid(),
    provider: z.nativeEnum(ExternalAccountProvider),
    providerId: z.string(),
    date: z.string().datetime(),
    payee: z.string().optional(),
    notes: z.string().optional(),
    inflow: z.coerce.number().optional(),
    outflow: z.coerce.number().optional(),
    syncTime: z.string().datetime(),
    timeCreated: z.string().datetime(),
    timeModified: z.string().datetime(),
});
